// In both Admin/logout.js and Customer/logout.js
import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthProvider';

const Logout = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  
  useEffect(() => {
    // Call the logout function from context
    logout();
    // Redirect to login page
    navigate('/');
  }, []);
  
  return <div>Logging out...</div>;
};

export default Logout;